/**
 * @file Get an IndexedDB store
 */
import initDB from './initDB';
/**
 * Get an IndexedDB store
 *
 * @param which The store we want to get (eg. 'preferences')
 * @param mode  The mode we want to open the store in (read only or rw)
 * @returns     The store to use
 */
export const getStore = async (which, mode) => {
    const db = await initDB();
    const transaction = db.transaction(which, mode);
    return transaction.objectStore(which);
};
//# sourceMappingURL=getStore.js.map